/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type HomeScreenPresentationsList_query = {
    readonly presentations: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"PresentationCard_presentation">;
            };
        }>;
    } | null;
    readonly " $refType": "HomeScreenPresentationsList_query";
};
export type HomeScreenPresentationsList_query$data = HomeScreenPresentationsList_query;
export type HomeScreenPresentationsList_query$key = {
    readonly " $data"?: HomeScreenPresentationsList_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"HomeScreenPresentationsList_query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeScreenPresentationsList_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 4
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "CREATED_AT_DESC",
            "ID_ASC"
          ]
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "presentations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PresentationCard_presentation"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "presentations(first:4,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = 'e2a4f4bbd8dfbd060d90808fa08d1fd0';
export default node;
